import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCalendarChecked24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconCalendarChecked24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.5 2.75a.75.75 0 0 0-1.5 0V3H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3h-1v-.25a.75.75 0 0 0-1.5 0V3h-7zm7 2.5V4.5h-7v.75a.75.75 0 0 1-1.5 0V4.5H6A1.5 1.5 0 0 0 4.5 6v2.5h15V6A1.5 1.5 0 0 0 18 4.5h-1v.75a.75.75 0 0 1-1.5 0M4.5 18v-8h15v8a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 18m4.922-3.793a.75.75 0 1 0-1.061 1.06l1.958 1.959.53.53.53-.53 4.244-4.243a.75.75 0 0 0-1.061-1.06l-3.712 3.712z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCalendarChecked24);
